import activity from 'src/i18n/en-US/activity';
import agent from 'src/i18n/en-US/agent';
import alarm from 'src/i18n/en-US/alarm';
import app from 'src/i18n/en-US/app';
import appointment from 'src/i18n/en-US/appointment';
import changelog from 'src/i18n/en-US/changelog';
import common from 'src/i18n/en-US/common';
import contactInformation from 'src/i18n/en-US/contactInformation';
import dailyActivity from 'src/i18n/en-US/dailyActivity';
import document from 'src/i18n/en-US/document';
import filter from 'src/i18n/en-US/filter';
import genericList from 'src/i18n/en-US/genericList';
import ido from 'src/i18n/en-US/ido';
import idoContactPerson from 'src/i18n/en-US/idoContactPerson';
import login from 'src/i18n/en-US/login';
import mail from 'src/i18n/en-US/mail';
import main from 'src/i18n/en-US/main';
import memo from 'src/i18n/en-US/memo';
import menu from 'src/i18n/en-US/menu';
import message from 'src/i18n/en-US/message';
import note from 'src/i18n/en-US/note';
import phoneCall from 'src/i18n/en-US/phoneCall';
import settings from 'src/i18n/en-US/settings';
import setupWizard from 'src/i18n/en-US/setupWizard';
import share from 'src/i18n/en-US/share';
import spotlight from 'src/i18n/en-US/spotlight';
import status from 'src/i18n/en-US/status';
import tabManager from 'src/i18n/en-US/tabManager';
import task from 'src/i18n/en-US/task';
import timer from 'src/i18n/en-US/timer';
import userOnline from 'src/i18n/en-US/userOnline';
import userState from 'src/i18n/en-US/userState';
import workspace from 'src/i18n/en-US/workspace';
import workspaceTabs from 'src/i18n/en-US/workspaceTabs';

export default {
	...activity,
	...agent,
	...alarm,
	...app,
	...appointment,
	...changelog,
	...common,
	...contactInformation,
	...dailyActivity,
	...document,
	...filter,
	...genericList,
	...login,
	...ido,
	...idoContactPerson,
	...mail,
	...main,
	...memo,
	...menu,
	...message,
	...note,
	...phoneCall,
	...settings,
	...setupWizard,
	...share,
	...spotlight,
	...status,
	...tabManager,
	...task,
	...timer,
	...userOnline,
	...userState,
	...workspace,
	...workspaceTabs,
};
